import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { OPT_IN_CONTENT_BLOCKER } from "../../types";
import { OPT_IN_EVENT } from "../../types";
import { putHtmlCodeToDom } from "..";
import { waitObject } from "../../utils";
var amazonWidgetsSlotNum = 0;
/**
 * Some presets have custom opt-in coding, e. g. Amazon Widgets.
 */

function listenPresetOptIn() {
  document.addEventListener(OPT_IN_EVENT, /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref) {
      var _ref$detail$cookie, presetId, codeOptIn, codeDynamics, _ref3, amznAssoWidgetHtmlId, element, slotNum, adContainer;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _ref$detail$cookie = _ref.detail.cookie, presetId = _ref$detail$cookie.presetId, codeOptIn = _ref$detail$cookie.codeOptIn, codeDynamics = _ref$detail$cookie.codeDynamics;
              _context2.t0 = presetId;
              _context2.next = _context2.t0 === "amazon-associates-widget" ? 4 : _context2.t0 === "google-maps" ? 16 : 18;
              break;

            case 4:
              _ref3 = codeDynamics || {}, amznAssoWidgetHtmlId = _ref3.amznAssoWidgetHtmlId;

              if (!amznAssoWidgetHtmlId) {
                _context2.next = 15;
                break;
              }

              element = document.getElementById(amznAssoWidgetHtmlId);

              if (!element) {
                _context2.next = 15;
                break;
              }

              slotNum = amazonWidgetsSlotNum;
              amazonWidgetsSlotNum++;
              putHtmlCodeToDom(codeOptIn, codeDynamics, element); // Amazon Widgets is using `document.write`, we need to manually move the ad container...

              _context2.next = 13;
              return waitObject(function () {
                return document.querySelector("[id^=\"amzn_assoc_ad_div_\"][id$=\"".concat(slotNum, "\"]"));
              }, 500, 50);

            case 13:
              adContainer = _context2.sent;

              if (adContainer) {
                element.appendChild(adContainer);
              }

            case 15:
              return _context2.abrupt("break", 19);

            case 16:
              document.addEventListener(OPT_IN_CONTENT_BLOCKER, /*#__PURE__*/function () {
                var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref4) {
                  var element, _ref6, et_pb_map_init;

                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          element = _ref4.detail.element;
                          _ref6 = window, et_pb_map_init = _ref6.et_pb_map_init;

                          if (!(jQuery && element.matches(".et_pb_map") && et_pb_map_init)) {
                            _context.next = 6;
                            break;
                          }

                          _context.next = 5;
                          return waitObject(function () {
                            return window.google;
                          });

                        case 5:
                          et_pb_map_init(jQuery(element).parent());

                        case 6:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function (_x2) {
                  return _ref5.apply(this, arguments);
                };
              }());
              return _context2.abrupt("break", 19);

            case 18:
              return _context2.abrupt("break", 19);

            case 19:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }());
}

export { listenPresetOptIn };